import React, { Component, Suspense } from "react";
import BackToTop from "./backToTop";
import withRouter from "../../common/data/withRouter";
import ScrollToHashElement from "../Shared/ScrollToHashElement";

// Layout Components
const Topbar = React.lazy(() => import("./Topbar"));

const Loader = () => {
  return (
    <div id="preloader">
      <div id="status">
        <div className="spinner">
          <div className="double-bounce1"></div>
          <div className="double-bounce2"></div>
        </div>
      </div>
    </div>
  );
};

class Layout extends Component { 
  render() {
    return (
      <React.Fragment>
        <Suspense fallback={Loader()}>
          <ScrollToHashElement />
          <Topbar hasDarkTopBar={this.props.hasDarkTopBar} />

          {this.props.children}

          <BackToTop />
        </Suspense>

      </React.Fragment>
    );
  }
}

export default withRouter(Layout);
